import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeSpec } from './NodeSpec';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';

export const boolCastNodeSpec: NodeSpec<NodeCfg<'boolCast'>> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: {}, id: getUID(), kind: 'boolCast', disabled: false }),
    controls: () => ({}),
    inputs: () => ({ input: { socket: 'varValue', label: 'Input' } }),
    kindLabel: 'Boolean Value Cast',
    nodeCategory: 'boolean',
    outputs: () => ({ output: { socket: 'boolean', label: 'Output' } }),
    validator: () => true,
};
